import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: 'auto',
    margin: theme.spacing(4.1825, 19.625, 0, 19),
    ['@media(max-width:1600px)']: {
      margin: theme.spacing(6, 19.25, 19.25, 19.25),
    },
    ['@media(min-width:1600px)']: {
      margin: theme.spacing(6, 16.25, 16.25, 16.25),
      minWidth: '1193px',
    },
    ['@media(max-width:1290px)']: {
      minWidth: '1193px',
    },
  },
  button: {
    marginTop: theme.spacing(4),
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  reviewRoot: {
    minHeight: '488px',
    width: '643px',
    boxSizing: 'border-box',
    margin: theme.spacing(4.125, 'auto', 0, 'auto'),
    backgroundColor: theme.palette.bg.main,
    padding: theme.spacing(10),
  },
  reviewButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: theme.spacing(4.1),
  },
  backToPageButton: {
    marginRight: theme.spacing(1),
  },
  cancelButton: {
    marginRight: theme.spacing(1.25087),
  },
  modalContent: {
    fontSize: '18px',
  },
}))
